import { render, staticRenderFns } from "./list.vue?vue&type=template&id=6ba9ee58&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=6ba9ee58&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba9ee58')) {
      api.createRecord('6ba9ee58', component.options)
    } else {
      api.reload('6ba9ee58', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=6ba9ee58&", function () {
      api.rerender('6ba9ee58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/list.vue"
export default component.exports